/**
 * Export en import van de opgeslagen spelstand.
 *
 * De spelstand van beide spellen leeft in sessionStorage (zie main.js). Een
 * export zet die stand in één JSON-bestand, een import zet ze terug. Zo kan een
 * spel bewaard worden voor de tab gesloten wordt, of overgezet worden naar een
 * ander toestel.
 */

export const EXPORT_APP = 'whist-scoring'
export const EXPORT_VERSION = 1

/** De spellen die mee geëxporteerd worden, met hun naam voor de gebruiker. */
export const GAME_LABELS = {
  game: 'Kleurenwiezen',
  boerenbridge: 'Boerenbridge'
}

export const GAME_KEYS = Object.keys(GAME_LABELS)

export function buildExport(games, now = new Date()) {
  return {
    app: EXPORT_APP,
    version: EXPORT_VERSION,
    exportedAt: now.toISOString(),
    games
  }
}

export function exportFilename(now = new Date()) {
  const pad = (value) => String(value).padStart(2, '0')
  const stamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}`
  return `whist-scoring-${stamp}.json`
}

function isPlainObject(value) {
  return !!value && typeof value === 'object' && !Array.isArray(value)
}

/**
 * Leest een exportbestand uit. Gooit een Error met een leesbare melding wanneer
 * het bestand niet bruikbaar is.
 */
export function parseExport(text) {
  let parsed
  try {
    parsed = JSON.parse(text)
  } catch (e) {
    throw new Error('Dit is geen geldig JSON-bestand.')
  }

  if (!isPlainObject(parsed)) throw new Error('Dit bestand bevat geen spelstand.')
  if (parsed.app && parsed.app !== EXPORT_APP) throw new Error('Dit bestand hoort bij een andere app.')
  if (Number(parsed.version) > EXPORT_VERSION) throw new Error('Dit bestand komt van een nieuwere versie van de app.')

  // 'games' is de huidige vorm, 'data' laat ruimte voor een oudere sleutelnaam
  const source = isPlainObject(parsed.games) ? parsed.games : parsed.data
  if (!isPlainObject(source)) throw new Error('Dit bestand bevat geen spelstand.')

  const games = {}
  for (const key of GAME_KEYS) {
    if (isPlainObject(source[key])) games[key] = source[key]
  }
  if (!Object.keys(games).length) throw new Error('Dit bestand bevat geen spelstand.')

  return games
}

/** Korte omschrijving van wat er in een import zit, voor de bevestiging. */
export function describeGames(games) {
  const parts = []
  for (const key of GAME_KEYS) {
    const state = games[key]
    const players = Array.isArray(state?.players) ? state.players.length : 0
    if (!players) continue
    const rounds = Array.isArray(state?.roundHistory) ? state.roundHistory.length : 0
    const played = rounds === 1 ? '1 gespeelde ronde' : `${rounds} gespeelde rondes`
    parts.push(`${GAME_LABELS[key]} met ${players} spelers en ${played}`)
  }
  return parts.length ? parts.join(', ') : 'een spel dat nog niet gestart is'
}
